export default "__VITE_ASSET__CTkZY7uk__"